import PropTypes from "prop-types";
import React, { useEffect, useRef, useCallback, Fragment } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import { Permissions } from "../../constants/enums";
import { createSelector } from "reselect";
import { useSelector } from "react-redux"

const SidebarClient = ({ userPermissions, t }) => {
  const ref = useRef();
  const path = useLocation();
  const hideSections = true;

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El = parent.childNodes && parent.childNodes.length && parent.childNodes[1]
          ? parent.childNodes[1]
          : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }


  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );
  
  const { token, loading, data } = useSelector(LoginProperties);

  const dashboardMenuItem =
  data.data?.roles !== "EMPLOYEE" ? (
    <li>
      <Link to="/dashboard" className="Dashboards">
        <i className="bx bx-home-circle"></i>
        <span>{t("Dashboard")}</span>
      </Link>
    </li>
  ) : null;

  return (
    <Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("Menu")}</li>
              {dashboardMenuItem}
            <li className="menu-title">{t("Administration")}</li>
              <li>
                <Link to="/services" className="has-arrow">
                  <i className="bx bx-task"></i>
                  <span>{t("Services")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/services/request">{t("Requests")}</Link>
                  </li>
                  <li>
                    <Link to="/services/reservations">{t("Reservations")}</Link>
                  </li>
                  <li>
                    <Link to="/services/historical">{t("Historical")}</Link>
                  </li>
                </ul>
              </li>

            {userPermissions.includes(Permissions.CONTROL_TOWER_SERVICES_READ) ? (
              <li>
                <Link to="/control-tower" className="has-arrow">
                  <i className="bx bx-map"></i>
                  <span>{t("ControlTower")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/control-tower/services-map">
                      {t("ServicesMap")}
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}
              
            {userPermissions.includes(Permissions.EMPLOYEES_READ) && (
              <li>
                <Link to="/employee" className="has-arrow">
                  <i className="bx bx-group"></i>
                  <span>{t("Employees")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/employees">{t("ManageEmployees")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {userPermissions.includes(Permissions.COST_CENTER_READ) && (
              <li>
                <Link to="/cost-center" className="has-arrow">
                  <i className="bx bx-list-ul"></i>
                  <span>{t("CostCenter")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/cost-centers">{t("AdminCostCenter")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {userPermissions.includes(Permissions.USERS_READ) && (
              <li>
                <Link to="/user" className="has-arrow">
                  <i className="bx bx-user-circle"></i>
                  <span>{t("Users")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/users">{t("AdminUsers")}</Link>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </Fragment>
  );
};

SidebarClient.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarClient));
